@if (isAdmin && dataCatalogStatus?.status != 'READY' && dataCatalogStatus?.status != 'PRISTINE') {
  <button class="btn btn-danger d-block w-100 mb-2" (click)="resetUpload()">{{ "Template.MainComponent.label_resetUpload" | translate }}</button>
}

@if (isAdmin) {
  <button class="btn btn-danger d-block w-100 mb-2" (click)="resetProductData()" [disabled]="dataCatalogStatus?.status != 'READY'">{{ "Template.MainComponent.label_deleteProducts" | translate }}</button>
}

<a class="btn btn-secondary d-block w-100" [href]="'/assets/data/supplier-data-template-' + currentLanguage?.toUpperCase() + '.xlsx'" download>{{ "Template.MainComponent.label_downloadTemplate" | translate }} </a>
<a class="btn btn-link btn-sm d-block w-100 mb-3 text-center" [href]="'/assets/data/supplier-data-template-description-' + currentLanguage?.toUpperCase() + '.pdf'" download>
  <fa-icon [icon]="'info-circle'" class="mr-2"></fa-icon>
  {{ "Template.MainComponent.label_downloadTemplateDescription" | translate }}
</a>

@if (dataCatalogStatus?.status != 'PRISTINE') {
  <button class="btn btn-secondary d-block w-100 mb-2" (click)="getUploadedFile()">{{ "Template.MainComponent.label_downloadUploadedFile" | translate }}</button>
}

@if (dataCatalogStatus?.status == 'READY') {
  <button class="btn btn-secondary d-block w-100 mb-2" (click)="requestDownload()" [disabled]="requestingDownload">
    {{ "Template.MainComponent.label_downloadGeneratedFile" | translate }}
    @if (requestingDownload) {
      <fa-icon [icon]="'spinner'" animation="spin"></fa-icon>
    }
  </button>
}
